import LinkIcon from "@mui/icons-material/Link";
import Button, { type ButtonProps } from "@mui/material/Button";
import { CustomLink } from "./CustomLink";

export function LinkButton({
  disabled = false,
  children,
  ...rest
}: ButtonProps) {
  return (
    <Button
      variant="outlined"
      LinkComponent={CustomLink}
      color="primary"
      startIcon={<LinkIcon />}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}
